module.exports = __webpack_public_path__ + "img/IMG_0079_L_BlackMatted.b427e420.jpg";